// extracted by mini-css-extract-plugin
module.exports = {"modifiersRow":"ProductModifers_modifiersRow__1lmKt","modifierSelect":"ProductModifers_modifierSelect__1R5vl","labelSecondary":"ProductModifers_labelSecondary__3IXVv"};